export type AIModel = 'gemini' | 'grok' | 'open';

export class ModelToView {
  public static toView(model: AIModel): { name: string; version: string } {
    switch (model) {
      case 'gemini': {
        return {
          name: 'Gemini',
          version: 'gemini-2.5-pro',
        };
      }

      case 'grok': {
        return {
          name: 'Grok',
          version: 'grok-3',
        };
      }

      case 'open': {
        return {
          name: 'OpenAI',
          version: 'gpt-4o',
        };
      }

      default: {
        const _: never = model;

        return {
          name: model,
          version: model,
        };
      }
    }
  }
}
